
import HomeButton from '../components/button/home.vue'
import ButtonHome from "../components/button/home.vue";
export default {
  props: ["error"],
  components: {ButtonHome, HomeButton },
  created() {
    this.$router.push({
        path: `/`
    })
  },
  methods: {
    linkHome() {
      this.$router.push({
        path: `/`
      })
    }
  }
}
